import React, {useEffect, useState} from 'react';
import Dropzone from 'react-dropzone';
import "./CreateProduct.css";
import Scrollbar from "react-scrollbars-custom";
import Grid from "@mui/material/Grid";
import { makeStyles } from '@mui/styles';
import Stepper from '@mui/material/Stepper';
import Step from '@mui/material/Step';
import StepLabel from '@mui/material/StepLabel';
import Button from '@mui/material/Button';
import Typography from '@mui/material/Typography';
import FormControlLabel from "@mui/material/FormControlLabel";
import Checkbox from "@mui/material/Checkbox";
import DatePicker from "react-datepicker2";
import axios from "axios"
import Dialog from "@mui/material/Dialog";
import DialogContent from "@mui/material/DialogContent";
import DialogActions from "@mui/material/DialogActions";
import TableContainer from "@mui/material/TableContainer";
import Table from "@mui/material/Table";
import TableRow from "@mui/material/TableRow";
import TableCell from "@mui/material/TableCell";
import TableBody from "@mui/material/TableBody";
import Paper from "@mui/material/Paper";
import {strings} from "../../../strings"
import {SnackbarProvider} from "notistack";
import TextField from "@mui/material/TextField";
import Autocomplete from "@mui/material/Autocomplete";
import {useDispatch, useSelector} from "react-redux";
import noContent from "../../../Image/noContent.svg"
import CheckBoxOutlineBlankIcon from "@mui/icons-material/CheckBoxOutlineBlank";
import CheckBoxIcon from "@mui/icons-material/CheckBox";
import CloseIcon from "@mui/icons-material/Close";
import ClickAwayListener from "@mui/material/ClickAwayListener";
import MenuItem from "@mui/material/MenuItem";
import Tooltip from "@mui/material/Tooltip";
import ExpandLessIcon from "@mui/icons-material/ExpandLess";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";

const useStyles = makeStyles((theme) => ({
    root: {
        width: '100%',
    },
    button: {
        marginRight: theme.spacing(1),
    },
    instructions: {
        marginTop: theme.spacing(1),
        marginBottom: theme.spacing(1),
    },
}));

function getSteps() {
    return ['درج اطلاعات پایه', 'اطلاعات تکمیلی', 'بارگذاری فایل', 'تاییدیه'];
}

const initialState = {
    iSBNBook: "",
    activationOfISBNPeriodicWorks: false,
    periodicISBN: "",
    bookName: "",
    description: "",
    bookPrice: "",
};


const icon = <CheckBoxOutlineBlankIcon fontSize="small"/>;
const checkedIcon = <CheckBoxIcon fontSize="small"/>;

function CreateProduct() {

    const classes = useStyles();
    const [activeStep, setActiveStep] = React.useState(0);
    const [skipped, setSkipped] = React.useState(new Set());
    const [{bookName, description, bookPrice, category},
        setStaticState] = useState(initialState);
    const [state, setStates] = useState({});
    const [files, setFiles] = useState([])
    const [priceString, setPriceString] = useState("");
    const [openDialog, setOpenDialog] = useState(false);
    const [typeProduct, setTypeProduct] = useState("");
    const [allProductType, setAllProductType] = useState(null);
    const [allAttributes, setAllAttributes] = useState(null);
    const [productTypeId, setProductTypeId] = useState(null);
    const [attributeJson, setAttributeJson] = useState([]);
    const [allCategory, setAllCategory] = useState(null);
    const [categoryId, setCategoryId] = useState(null);
    const [allTags, setAllTags] = useState(null);
    const [selectiveTag, setSelectiveTag] = useState(null);
    const [selected, setSelected] = useState([]);
    const [open, setOpen] = useState(false);

    const handleClick = () => {
        setOpen((prev) => !prev);
    };

    const handleClickAway = () => {
        setOpen(false);
    };

    function handleCheck(id) {
        if(selected.includes(id)){
            let array = selected.filter(x=>x !== id);
            setSelected(array);
        }else setSelected([...selected,id])
    }

    const steps = getSteps();
    const dispatch = useDispatch();
    const mToken = useSelector(store => store.app.token.adminToken);


    function ClickAwayMenu(props) {

        const [subOpen, setSubOpen] = useState(false);

        function handleClickAway() {
            setSubOpen(false);
        }

        function handleClick() {
            setSubOpen((prev) => !prev);
        }

        function findChild(length, result) {
            if (length === 0) {
                return (
                    <MenuItem className="p-0">
                        <div
                            className="w-100 d-flex"
                        >
                            <Checkbox
                                color="primary"
                                checked={selected.includes(result)}
                                inputProps={{ 'aria-label': 'secondary checkbox' }}
                                onChange={()=>handleCheck(result)}
                            />
                            <h3 className="SubTextMain w-100 pr-4 pl-3">
                                {result.name}
                            </h3>
                        </div>
                    </MenuItem>
                )
            } else {
                return (
                    <MenuItem className="p-0">
                        {/*<ClickAwayMenu  data={result}/>*/}
                        <Tooltip
                            title={
                                <div className="subMenuMain">
                                    {result.children.map(x => {
                                        return findChild(x.children.length, x);
                                        // <li key={i}>{x.name}</li>
                                    })}
                                </div>
                            }
                            interactive
                            placement="left-start"
                        >
                            <div
                                className="d-flex justify-content-between align-items-center w-100 pl-2">
                                <div className="d-flex align-items-center">
                                    <Checkbox
                                        color="primary"
                                        checked={selected.includes(result)}
                                        inputProps={{ 'aria-label': 'secondary checkbox' }}
                                        onChange={()=>handleCheck(result)}
                                    />
                                    <h3 className="SubTextMain">
                                        {result.name}
                                    </h3>
                                </div>
                                <i className="fas fa-chevron-left leftArrowChevron"/>
                            </div>
                        </Tooltip>
                    </MenuItem>
                )
            }
        }

        return (
            <div
                className={`d-flex flex-column justify-content-center position-relative unitsMenu`}

            >
                <div
                    className={`d-flex BoxMenuMain justify-content-center align-items-center py-2 ${props.data.data ? "px-3" : ""}`}
                >
                    {props.data.children ?
                        subOpen ?
                            <ExpandLessIcon onClick={()=>setSubOpen(!subOpen)}/>
                            :
                            <ExpandMoreIcon onClick={()=>setSubOpen(!subOpen)}/>
                        :
                        null
                    }
                    <h3 className="">
                        {props.data.name}
                    </h3>
                </div>

                {props.data.children &&
                subOpen ?
                    <div className="d-flex flex-column">
                        {props.data.children && props.data.children.map(result => (
                            findChild(result.children.length, result)
                        ))}
                    </div>
                    : null
                }
            </div>
        )
    }

    const forms = [
        {
            label: "عنوان کتاب",
            value: bookName,
            name: "bookName",
        },
        {
            label: "دسته بندی",
            value: category,
            name: "category",
        },
        {
            label: "توضیحات",
            value: description,
            name: "description",
        },
        {
            label: "قیمت کتاب",
            value: bookPrice,
            name: "bookPrice",
        }
    ];

    function setParametersStatic(event) {
        const {value, name} = event.target;
        setStaticState(prevState => ({...prevState, [name]: value}));
    }

    function changeNumberToString(value, name) {
        if (name === "bookPrice") {
            if (value !== "" && value !== undefined) {
                return (value / 10).toPersianLetter()
            } else return ""
            // setPriceString("")
        } else {
            if (value !== "" && value !== undefined) {
                return value.toPersianLetter()
            } else return ""
        }
    }

    function setParameters(event) {
        const {value, name} = event.target;
        setStates(prevState => ({...prevState, [name]: value}));
    }

    const isStepSkipped = (step) => {
        return skipped.has(step);
    };


    async function sendProduct() {
        let newSkipped = skipped;
        const dataTable = {
            product_type_id: productTypeId,
            category_id: [],
            name: bookName,
            description: description,
            price: bookPrice,
            attributes: JSON.stringify(attributeJson),
            image: files,
            tags: []
        };
        const formData = new FormData();
        for (let keyName in dataTable) {
            if (keyName === "image") {
                files.map((x, i) => (
                    formData.append(`image[${i}]`, files[i])
                ))
            } else if (keyName === "attributes") {
                allAttributes.map((x, i) => {
                    formData.append(`attributes[${x.id}][name]`, state[x.name]);
                    formData.append(`attributes[${x.id}][description]`, x.description)
                });
            } else if (keyName === "tags") {
                selectiveTag.length !== 0 ?
                    selectiveTag.map((x, i) => {
                        formData.append(`tags[${i}]`, selectiveTag[i])
                    })
                    :
                    formData.append(`tags`, [])
            } else if (keyName === "category_id"){
                selected.length !== 0 ?
                    selected.map((x, i) => {
                        formData.append(`categories[${i}]`, selected[i].id)
                    })
                    :
                    formData.append(`categories`, [])
            } else formData.append(keyName, dataTable[keyName]);
        }
        axios({
            method: 'post',
            url: strings.baseUrl + `product`,
            data: formData,
            headers: {
                "content-type": "multipart/form-data",
                "Authorization": `Bearer ${mToken}`
            }
        })
            .then(result => {
                if (result.data.status_code === 200) {
                    setActiveStep((prevActiveStep) => prevActiveStep + 1);
                    setSkipped(newSkipped);
                    setStaticState(initialState)
                    setFiles([])
                }else if(result.data.status_code === 401){
                    dispatch({type: "SET_ADMIN_TOKEN", data: ""})
                }
            })
            .catch(error => {
                console.log(error);
            })
    }

    function setAttributesToJson() {
        allAttributes !== null && allAttributes.forEach(item => {
            setAttributeJson((res) => ({
                ...res,
                [`${item.id}`]: {"name": `${state[item.name]}`, "description": `${item.description}`}
            }))
        })
    }

    const handleNext = () => {
        let newSkipped = skipped;
        if (isStepSkipped(activeStep)) {
            newSkipped = new Set(newSkipped.values());
            newSkipped.delete(activeStep);
        }
        if (activeStep === 2) {
            setAttributesToJson();
            setActiveStep((prevActiveStep) => prevActiveStep + 1);
            setSkipped(newSkipped);
        } else if (activeStep === 3) {
            sendProduct();
        } else {
            setActiveStep((prevActiveStep) => prevActiveStep + 1);
            setSkipped(newSkipped);
        }
    };

    const handleBack = () => {
        setActiveStep((prevActiveStep) => prevActiveStep - 1);
    };


    const handleReset = () => {
        setStates({});
        setActiveStep(0);
    };

    const handleClose = () => {
        setOpenDialog(false);
    };

    function setTime(e, name) {

        setStates(prevState => (
            {
                ...prevState, [name]: e.format(`jYYYY/jMM/jDD`),
                [`dateForSend`]: e.format(`YYYY/MM/DD`)
            }
        ));
    }

    function humanFileSize(size) {
        if (size < 1024) return size + ' B';
        let i = Math.floor(Math.log(size) / Math.log(1024));
        let num = (size / Math.pow(1024, i));
        let round = Math.round(num);
        num = round < 10 ? num.toFixed(2) : round < 100 ? num.toFixed(1) : round;
        return `${num} ${'KMGTPEZY'[i - 1]}B`
    }

    async function getProductType() {
        await axios.get(strings.baseUrl + `product-type`)
            .then(result => {
                if (result.data.status_code === 200) {
                    setAllProductType(result.data.data.product_types);
                    setOpenDialog(true)
                }else if(result.data.status_code === 401){
                    dispatch({type: "SET_ADMIN_TOKEN", data: ""})
                }
            })
            .catch(error => {
                console.log(error)
            })
    }

    function setAllAttributesOfProductType(data) {
        if (data) {
            data.map(res => {
                res.attributes.forEach(item => {
                    setStates(prevState => ({...prevState, [item.name]: ""}));
                    setAllAttributes(res.attributes);
                    setProductTypeId(res.id);
                })
            })

        }
        handleClose()
    }

    async function getAllCategory() {
        await axios.get(strings.baseUrl + `category`)
            .then(result => {
                if (result.data.status_code === 200) {
                    setAllCategory(result.data.data.categories)
                }else if(result.data.status_code === 401){
                    dispatch({type: "SET_ADMIN_TOKEN", data: ""})
                }
            })
            .catch(error => {
                console.log(error)
            })
    }

    async function getAllTags() {
        await axios.get(strings.baseUrl + `tag`)
            .then(result => {
                if (result.data.status_code === 200) {
                    setAllTags(result.data.data.tags)
                }else if(result.data.status_code === 401){
                    dispatch({type: "SET_ADMIN_TOKEN", data: ""})
                }
            })
            .catch(error => {
                console.log(error)
            })
    }

    useEffect(() => {
        setOpenDialog(true)
    }, []);

    useEffect(() => {
        getProductType();
        getAllCategory();
        getAllTags()
    }, [])

    function onDrop(acceptedFiles) {
        acceptedFiles.map(file => {
            setFiles([...files, file])
        })
    }

    function onDropFiles(acceptedFiles, name) {
        setStates(prevState => ({...prevState, [name]: acceptedFiles[0]}));
    }

    return (
        <Scrollbar className="ScrollDebt">
            <Dialog aria-labelledby="customized-dialog-title" open={openDialog} onClose={() => setOpenDialog(false)}>
                <div className="ParentTitleDialogBoxCreateProduct">
                    <h3 className="titleDialogBoxCreateProduct">201- انتخاب نوع محصول جدید</h3>
                    {/*<i*/}
                    {/*    className="fas fa-times c-pointer"*/}
                    {/*    onClick={() => setOpenDialog(false)}*/}
                    {/*/>*/}
                </div>
                <DialogContent dividers>
                    <div className="ParentContentDialogCreateProduct">
                        {allProductType !== null &&
                        allProductType.length !== 0 ? allProductType.map((data, i) => (
                                <h3
                                    key={i}
                                    className={`unitDialogProduct ${typeProduct === data.name ? "selectedTypeProduct" : ""}`}
                                    onClick={() => setTypeProduct(data.name)}
                                >{data.name}</h3>
                            ))
                            :
                            <img src={noContent} alt="" className="noContent"/>
                        }
                    </div>
                </DialogContent>
                <DialogActions>
                    <Button autoFocus
                            disabled={typeProduct === ""}
                            onClick={() => setAllAttributesOfProductType(allProductType.filter(x => x.name === typeProduct))}>
                        تایید
                    </Button>
                </DialogActions>
            </Dialog>
            <Grid item lg={11} className="w-100 d-flex flex-column DivParentCreateProduct m-4">
                <div className="d-flex headerBoxCreateProduct">
                    <h3> 103 - </h3>
                    <h3> ایجاد محصول جدید</h3>
                </div>
                <div className={classes.root}>
                    <div className="w-75 divParentStepper">
                        <Stepper activeStep={activeStep}>
                            {steps.map((label, index) => {
                                const stepProps = {};
                                const labelProps = {};
                                if (isStepSkipped(index)) {
                                    stepProps.completed = false;
                                }
                                return (
                                    <Step key={label} {...stepProps}>
                                        <StepLabel {...labelProps}>{label}</StepLabel>
                                    </Step>
                                );
                            })}
                        </Stepper>
                    </div>
                    <div className="w-100">
                        {activeStep === steps.length ? (
                            <div>
                                <Typography className={classes.instructions}>
                                    با موفقیت ثبت شد
                                </Typography>
                                <Button onClick={handleReset} className={classes.button}>
                                    ایجاد دوباره
                                </Button>
                            </div>
                        ) : (
                            <div className="w-100">
                                {/*<input value={titration} name="titration" onChange={(e) => setParameters(e)}/>*/}
                                {/*{getStepContent(activeStep)}*/}
                                {activeStep === 0 &&
                                <div className="d-flex flex-column divParentBasicInformation">
                                    <div className="divParentTitleBasicInformation">
                                        <h3>اطلاعات پایه</h3>
                                        <hr className="w-100"/>
                                        <i
                                            // onClick={() => {
                                            //     setOpen(!open)
                                            // }}
                                            className="fas fa-chevron-down"
                                            // style={{transform: open ? "rotate(180deg)" : ""}}
                                        />
                                    </div>
                                    {/*{open &&*/}
                                    <div className="d-flex flex-wrap divParentContentBasicInformation mt-2">
                                        {forms.map((data, i) => (
                                            data.name === "bookName" &&
                                            <Grid item key={i}
                                                  lg={4} xl={4}
                                                  className="d-flex justify-content-center align-items-center"
                                            >
                                                <div
                                                    className={`ContentCreateAttribute`}
                                                >
                                                    <TextField
                                                        key={i}
                                                        label={data.label}
                                                        variant="outlined"
                                                        name={data.name}
                                                        value={data.value}
                                                        className={`w-100 ${data.name === "description" && `descriptionInput`}`}
                                                        onChange={(e) => setParametersStatic(e)}
                                                    />
                                                </div>
                                            </Grid>
                                        ))}
                                        {forms.map((data, i) => (
                                            data.name === "category" &&
                                            <Grid item key={i}
                                                  lg={4} xl={4}
                                                  className="d-flex justify-content-center align-items-center parentMultiselectProductType p-0"
                                            >
                                                <>
                                                <div
                                                    className={`ContentCreateAttribute`}
                                                >

                                                    {allCategory !== null &&
                                                    <ClickAwayListener
                                                        mouseEvent="onMouseDown"
                                                        touchEvent="onTouchStart"
                                                        onClickAway={handleClickAway}
                                                    >
                                                        <div className="parentBoxCategory">
                                                            <div className='d-flex flex-wrap'>
                                                                {selected.map((item,i)=>(
                                                                    <div className="parentSelectedItem">
                                                                        <span>{item.name}</span>
                                                                        <CloseIcon onClick={()=>handleCheck(item)}/>
                                                                    </div>
                                                                ))}
                                                                <input
                                                                    id="outlined-basic"
                                                                    className='w-100'
                                                                    // label="Outlined"
                                                                    // variant="outlined"
                                                                    placeholder="دسته بندی"
                                                                    onFocus={handleClick}
                                                                />
                                                            </div>

                                                            {open ? (
                                                                <div className="boxPaperDropCategory">
                                                                    {allCategory.map((data, i) => {
                                                                        return <ClickAwayMenu key={i} data={data} number={i}/>
                                                                    })}
                                                                </div>
                                                            ) : null}
                                                        </div>
                                                    </ClickAwayListener>
                                                    // <Autocomplete
                                                    //     limitTags={1}
                                                    //     key={i}
                                                    //     className="w-100"
                                                    //     aria-readonly={true}
                                                    //     openOnFocus={true}
                                                    //     getOptionLabel={(option) => option.name}
                                                    //     onInputChange={(event, value) => {
                                                    //         let res = allCategory.filter(x => x.name === value);
                                                    //         if (res.length === 1) {
                                                    //             setCategoryId(res[0])
                                                    //         }
                                                    //     }}
                                                    //     options={allCategory}
                                                    //     renderGroup={}
                                                    //     style={{width: "100%"}}
                                                    //     renderInput={(params) =>
                                                    //         <>
                                                    //         <TextField {...params}
                                                    //                    label={data.label}
                                                    //                    variant="outlined"
                                                    //         />
                                                    //         <h3>eee</h3>
                                                    //         </>
                                                    //     }
                                                    // />
                                                    }
                                                </div>
                                                </>
                                            </Grid>
                                        ))}
                                        {allTags !== null &&
                                        <Grid item
                                              lg={4} xl={4}
                                              className="d-flex justify-content-center align-items-center parentMultiselectProductType p-0"
                                        >
                                            <div
                                                className={`ContentCreateAttribute`}
                                            >
                                                <Autocomplete
                                                    limitTags={1}
                                                    multiple
                                                    id="checkboxes-tags-demo"
                                                    className="w-100"
                                                    defaultValue={selectiveTag !== null ? allTags.filter(x=>selectiveTag.includes(x.id)) : []}
                                                    options={allTags}
                                                    disableCloseOnSelect
                                                    getOptionLabel={(option) => option.name}
                                                    onChange={(event, value) => {
                                                        let arr = [];
                                                        value.map(item => {
                                                            arr.push(item.id)
                                                        });
                                                        setSelectiveTag(arr)
                                                    }}
                                                    renderOption={(option, {selected}) => (
                                                        <React.Fragment>
                                                            <Checkbox
                                                                icon={icon}
                                                                checkedIcon={checkedIcon}
                                                                style={{marginRight: 8}}
                                                                checked={selected}
                                                            />
                                                            {option.name}
                                                        </React.Fragment>
                                                    )}
                                                    style={{width: 500}}
                                                    renderInput={(params) => (
                                                        <TextField {...params} variant="outlined"
                                                                   label="برچسب های محصول"
                                                                   placeholder="انتخاب برچسب"/>
                                                    )}
                                                />
                                            </div>
                                        </Grid>
                                        }
                                        {allAttributes !== null && allAttributes.map((data, i) => (
                                            data.name !== "weight" && data.name !== "pageNumber" &&
                                            <Grid item key={i}
                                                  lg={data.grid ? data.grid : 4}
                                                  className="d-flex justify-content-center align-items-center"
                                            >
                                                <div
                                                    className={`ContentCreateAttribute`}
                                                >

                                                    {data.type.name === "text" &&
                                                    <TextField
                                                        key={i}
                                                        label={data.label}
                                                        variant="outlined"
                                                        name={data.name}
                                                        value={state[data.name]}
                                                        className={`w-100 ${data.name === "description" && `descriptionInput`}`}
                                                        onChange={(e) => setParameters(e)}
                                                    />
                                                    }
                                                    {data.type.name === "checkbox" &&
                                                    <FormControlLabel
                                                        // value={data.value}
                                                        control={
                                                            <Checkbox
                                                                color="primary"
                                                                name={data.name}
                                                                onChange={() => setStates(prevState => ({
                                                                    ...prevState,
                                                                    [data.name]: !data.value
                                                                }))}
                                                            />
                                                        }
                                                        label={data.title}
                                                        // name={data.name}
                                                        labelPlacement="end"
                                                    />
                                                    }
                                                    {data.type.name === "dropdown" &&
                                                    <Autocomplete
                                                        key={i}
                                                        className="w-100"
                                                        value={data.type.value.filter(x=> x.id === state[data.name])[0]}
                                                        aria-readonly={true}
                                                        openOnFocus={true}
                                                        getOptionLabel={(option) => option.value ? option.value : "null"}
                                                        onInputChange={(event, value) => {
                                                            let res = data.type.value.filter(x => x.value === value);
                                                            if (res.length === 1) {
                                                                setStates(prevState => ({
                                                                    ...prevState,
                                                                    [data.name]: res[0].id
                                                                }));
                                                            }
                                                        }}
                                                        options={data.type.value}
                                                        style={{width: "100%"}}
                                                        renderInput={(params) =>
                                                            <TextField {...params}
                                                                       label={data.label}
                                                                       variant="outlined"
                                                            />
                                                        }
                                                    />
                                                    }
                                                    {data.type.name === "date" &&
                                                    <DatePicker
                                                        isGregorian={false}
                                                        className="DatePickerCreateProduct"
                                                        timePicker={false}
                                                        onChange={(e) => setTime(e, data.name)}
                                                    />
                                                    }
                                                    {data.type.name === "pdf" &&
                                                    <Dropzone onDrop={((acceptedFiles) => {
                                                        onDropFiles(acceptedFiles, data.name)
                                                    })}>
                                                        {({getRootProps, getInputProps}) => (
                                                            <div {...getRootProps()}>
                                                                <input {...getInputProps()} />
                                                                <div className="getFilePdf">
                                                                    <h3>{data.label}</h3>
                                                                    {state[data.name] === "" ?
                                                                        <i className="fas fa-upload"/> :
                                                                        state[data.name].name}
                                                                </div>
                                                            </div>
                                                        )}
                                                    </Dropzone>
                                                    }
                                                </div>
                                            </Grid>
                                        ))}
                                        {forms.map((data, i) => (
                                            data.name === "description" &&
                                            <Grid item key={i}
                                                  lg={12}
                                                  className="d-flex justify-content-center align-items-center"
                                            >

                                                <div
                                                    className={`ContentCreateAttribute`}
                                                >

                                                    <TextField
                                                        key={i}
                                                        label={data.label}
                                                        variant="outlined"
                                                        name={data.name}
                                                        value={data.value}
                                                        className={`w-100 ${data.name === "description" && `descriptionInput`}`}
                                                        onChange={(e) => setParametersStatic(e)}
                                                    />
                                                </div>
                                            </Grid>
                                        ))}
                                    </div>
                                </div>
                                }
                                {activeStep === 1 &&
                                <div className="d-flex flex-column divParentBasicInformation">
                                    <div className="divParentTitleBasicInformation">
                                        <h3>اطلاعات تکمیلی</h3>
                                        <hr className="w-100"/>
                                        <i
                                            // onClick={() => {
                                            //     setOpen(!open)
                                            // }}
                                            className="fas fa-chevron-down"
                                            // style={{transform: open ? "rotate(180deg)" : ""}}
                                        />
                                    </div>
                                    {/*{open &&*/}
                                    <div className="d-flex flex-wrap divParentContentBasicInformation mt-4">
                                        {forms.map((data, i) => (
                                            data.name === "bookPrice" &&
                                            <Grid item key={i}
                                                  lg={4} xl={4}
                                                  className="d-flex justify-content-center align-items-center"
                                            >
                                                <div
                                                    className={`d-flex position-relative w-100 ${data.name === "bookPrice" ? `blueText h-100` : `align-items-center`}`}
                                                    key={i}>
                                                    <div
                                                        className={`ContentCreateAttribute pl-0 flex-column ${
                                                            data.name === "bookPrice" ? `justify-content-start` : ``}`}
                                                    >
                                                        <TextField
                                                            key={i}
                                                            label={data.label}
                                                            variant="outlined"
                                                            name={data.name}
                                                            value={data.value}
                                                            className={`w-100 priceInput`}
                                                            onChange={(e) => setParametersStatic(e)}
                                                        />
                                                        <h3
                                                            style={{
                                                                opacity: (data.value !== "")
                                                                    ? "1" : "0"
                                                            }}
                                                        >{changeNumberToString(data.value, data.name)} تومان </h3>
                                                    </div>
                                                    {data.name === "bookPrice" && priceString !== "" &&
                                                    <h3>ریال</h3>
                                                    }
                                                    {/*{error &&*/}
                                                    {/*<i className="fas fa-info-circle"/>*/}
                                                    {/*}*/}
                                                </div>
                                            </Grid>
                                        ))}
                                        {allAttributes !== null && allAttributes.map((data, i) => (
                                            data.name === "weight" &&
                                            <Grid item key={i}
                                                  lg={4} xl={4}
                                                  className="d-flex justify-content-center align-items-center"
                                            >
                                                <div
                                                    className={`ContentCreateAttribute flex-column ${
                                                        data.focused ? `selected` : `unSelected`} ${
                                                        data.name === "bookPrices" ? `justify-content-start` : ``}`}
                                                >
                                                    {data.type.name === "text" &&
                                                    <TextField
                                                        key={i}
                                                        label={data.label}
                                                        variant="outlined"
                                                        name={data.name}
                                                        value={state[data.name]}
                                                        className={`w-100 ${data.name === "description" && `descriptionInput`}`}
                                                        onChange={(e) => setParameters(e)}
                                                    />
                                                    }
                                                    <h3 className="textSubWeight"
                                                        style={{
                                                            opacity: (state[data.name] !== "")
                                                                ? "1" : "0"
                                                        }}
                                                    >{changeNumberToString(state[data.name], data.name)} گرم </h3>
                                                </div>
                                            </Grid>
                                        ))}
                                    </div>
                                    {/*}*/}
                                </div>
                                }
                                {activeStep === 2 &&
                                <div className="d-flex flex-column divParentBasicInformation">
                                    <div className="divParentTitleBasicInformation">
                                        <h3>بارگذاری فایل</h3>
                                        <hr className="w-100"/>
                                        <i
                                            // onClick={() => {
                                            //     setOpen(!open)
                                            // }}
                                            className="fas fa-chevron-down"
                                            // style={{transform: open ? "rotate(180deg)" : ""}}
                                        />
                                    </div>
                                    {/*{open &&*/}
                                    <div className="d-flex flex-wrap divParentContentBasicInformation mt-4">
                                        <div className="w-100 d-flex flex-column justify-content-center">
                                            <Dropzone onDrop={onDrop}>
                                                {({getRootProps, getInputProps}) => (
                                                    <div {...getRootProps()}>
                                                        <input {...getInputProps()} />
                                                        <div className="d-flex justify-content-between">
                                                            <div
                                                                className="d-flex flex-column align-items-center parentTextUploadBox">
                                                                <h3>فایل مورد نظر را در این قسمت رها کنید و یا دکمه
                                                                    بارگذاری را کلیک نمایید</h3>
                                                                <h3>حجم فایل برای بارگذاری حداکثر بایستی ۱۰۰ کیلو بایت
                                                                    باشد</h3>
                                                            </div>
                                                            <div className="d-flex parentIconUploadBox">
                                                                <h3>انتخاب فایل</h3>
                                                                <i className="fas fa-user-alt"/>
                                                                <i className="fas fa-user-alt"/>
                                                            </div>
                                                        </div>
                                                    </div>
                                                )}
                                            </Dropzone>
                                            <div className="d-flex flex-wrap">
                                                {files.map((result, i) => (
                                                    <div className="parentUnitPreviewFile" key={i}>
                                                        <i
                                                            className="fas fa-times c-pointer"
                                                            onClick={() => setFiles(files.filter(x => x.name !== result.name))}
                                                        />
                                                        <div>
                                                            <h3>{result.name}</h3>
                                                            <h3 className="mt-3">{humanFileSize(result.size)}</h3>
                                                        </div>
                                                        <div>
                                                            <i className="far fa-file-image"/>
                                                            <h3 className="mt-1">{result.type}</h3>
                                                        </div>
                                                    </div>
                                                ))}
                                            </div>
                                            {/*<div*/}
                                            {/*    {...getRootProps({className: 'dropzone d-flex flex-row'})}*/}
                                            {/*>*/}
                                            {/*    <input {...getInputProps()} />*/}
                                            {/*    <h3 className="titleUpload">فایل های مورد نظر را در قسمت زیر بارگذاری کنید</h3>*/}
                                            {/*</div>*/}
                                            {/*<DropzoneArea*/}
                                            {/*    filesLimit={20}*/}
                                            {/*    onChange={(e) => setAllFiles(e)}*/}
                                            {/*    dropzoneText="بارگذاری"*/}
                                            {/*    showAlerts={false}*/}
                                            {/*    showFileNames={true}*/}
                                            {/*/>*/}
                                        </div>
                                    </div>
                                    {/*}*/}
                                </div>
                                }
                                {activeStep === 3 &&
                                <div className="d-flex flex-column divParentBasicInformation">
                                    <div className="divParentTitleBasicInformation">
                                        <h3>اطلاعات پایه</h3>
                                        <hr className="w-100"/>
                                        <i
                                            // onClick={() => {
                                            //     setOpen(!open)
                                            // }}
                                            className="fas fa-chevron-down"
                                            // style={{transform: open ? "rotate(180deg)" : ""}}
                                        />
                                    </div>
                                    {/*{open &&*/}
                                    <div className="d-flex flex-wrap divParentContentBasicInformation mt-4">
                                        {forms.map((data, i) => (
                                            data.name === "bookName" &&
                                            <Grid item key={i}
                                                  lg={4} xl={4}
                                                  className="d-flex justify-content-center align-items-center"
                                            >
                                                <div
                                                    className={`ContentCreateAttribute`}
                                                >

                                                    <TextField
                                                        label={data.label}
                                                        variant="outlined"
                                                        value={data.value}
                                                        className={`w-100`}
                                                        disabled
                                                    />
                                                </div>
                                            </Grid>
                                        ))}
                                        {forms.map((data, i) => (
                                            data.name === "category" &&
                                            <Grid item key={i}
                                                  lg={4} xl={4}
                                                  className="d-flex justify-content-center align-items-center"
                                            >
                                                <div
                                                    className={`ContentCreateAttribute`}
                                                >
                                                    {categoryId !== null &&
                                                    <TextField
                                                        label={data.label}
                                                        variant="outlined"
                                                        value={categoryId.name}
                                                        className={`w-100`}
                                                        disabled
                                                    />
                                                    }
                                                </div>
                                            </Grid>
                                        ))}
                                        {allTags !== null && selectiveTag !== null &&
                                        <Grid item
                                              lg={4} xl={4}
                                              className="d-flex justify-content-center align-items-center parentMultiselectProductType p-0"
                                        >
                                            <div
                                                className={`ContentCreateAttribute`}
                                            >
                                                <Autocomplete
                                                    limitTags={1}
                                                    multiple
                                                    disabled={true}
                                                    id="checkboxes-tags-demo"
                                                    className="w-100"
                                                    options={allTags}
                                                    defaultValue={() => {
                                                        let dd = [];
                                                        selectiveTag.map(x => {
                                                            let res = allTags.filter(rrr => rrr.id === x);
                                                            dd.push(allTags[allTags.findIndex(x => x.id === res[0].id)])
                                                        });
                                                        return dd
                                                    }
                                                    }
                                                    disableCloseOnSelect
                                                    getOptionLabel={(option) => option.name}
                                                    onChange={(event, value) => {
                                                        let arr = [];
                                                        value.map(item => {
                                                            arr.push(item.id)
                                                        })
                                                        setSelectiveTag(arr)
                                                    }}
                                                    renderOption={(option, {selected}) => (
                                                        <React.Fragment>
                                                            <Checkbox
                                                                icon={icon}
                                                                checkedIcon={checkedIcon}
                                                                style={{marginRight: 8}}
                                                                checked={selected}
                                                            />
                                                            {option.name}
                                                        </React.Fragment>
                                                    )}
                                                    style={{width: 500}}
                                                    renderInput={(params) => (
                                                        <TextField {...params} variant="outlined" label="برچسب های محصول"
                                                                   placeholder="انتخاب برچسب"/>
                                                    )}
                                                />
                                            </div>
                                        </Grid>
                                        }
                                        {allAttributes !== null && allAttributes.map((data, i) => (
                                            data.name !== "weight" && data.name !== "pageNumber" &&
                                            <Grid item key={i}
                                                  lg={data.grid ? data.grid : 4}
                                                  className="d-flex justify-content-center align-items-center"
                                            >
                                                <div
                                                    className={`ContentCreateAttribute`}
                                                >
                                                    <TextField
                                                        label={data.label}
                                                        variant="outlined"
                                                        value={
                                                            data.type.name === "dropdown" ?
                                                                data.type.value.filter(x => x.id === state[data.name])[0] &&
                                                                data.type.value.filter(x => x.id === state[data.name])[0].value
                                                                :
                                                                data.type.name === "pdf" ?
                                                                    state[data.name].name
                                                                    :
                                                                    state[data.name]
                                                        }
                                                        className={`w-100`}
                                                        disabled
                                                    />
                                                </div>
                                            </Grid>
                                        ))}
                                        {forms.map((data, i) => (
                                            data.name === "description" &&
                                            <Grid item key={i}
                                                  lg={12}
                                                  className="d-flex justify-content-center align-items-center"
                                            >
                                                <div
                                                    className={`ContentCreateAttribute`}
                                                >
                                                    <TextField
                                                        label={data.label}
                                                        variant="outlined"
                                                        value={data.value}
                                                        className={`w-100`}
                                                        disabled
                                                    />
                                                </div>
                                            </Grid>
                                        ))}
                                    </div>
                                    {/*}*/}
                                    <div className="divParentTitleBasicInformation">
                                        <h3>اطلاعات تکمیلی</h3>
                                        <hr className="w-100"/>
                                        <i
                                            // onClick={() => {
                                            //     setOpen(!open)
                                            // }}
                                            className="fas fa-chevron-down"
                                            // style={{transform: open ? "rotate(180deg)" : ""}}
                                        />
                                    </div>
                                    {/*{open &&*/}
                                    <div className="d-flex flex-wrap divParentContentBasicInformation mt-4">
                                        {forms.map((data, i) => (
                                            data.name === "bookPrice" &&
                                            <Grid item key={i}
                                                  lg={4} xl={4}
                                                  className="d-flex justify-content-center align-items-center"
                                            >
                                                <div
                                                    className={`d-flex position-relative w-100 ${data.name === "bookPrice" ? `blueText h-100` : `align-items-center`}`}
                                                    key={i}>
                                                    <div
                                                        className={`ContentCreateAttribute pl-0 flex-column ${
                                                            data.name === "bookPrices" ? `justify-content-start` : ``}`}
                                                    >
                                                        <TextField
                                                            label={data.label}
                                                            variant="outlined"
                                                            value={data.value}
                                                            className={`w-100`}
                                                            disabled
                                                        />
                                                        <h3
                                                            style={{
                                                                opacity: (data.name === "bookPrice" && priceString !== "")
                                                                    ? "1" : "0"
                                                            }}
                                                        >{priceString} تومان </h3>
                                                    </div>
                                                    {data.name === "bookPrice" && priceString !== "" &&
                                                    <h3>ریال</h3>
                                                    }
                                                </div>
                                            </Grid>
                                        ))}
                                        {allAttributes !== null && allAttributes.map((data, i) => (
                                            data.name === "pageNumber" &&
                                            <Grid item key={i}
                                                  lg={data.grid ? data.grid : 4}
                                                  className="d-flex justify-content-center align-items-center"
                                            >
                                                <div
                                                    className={`ContentCreateAttribute `}
                                                >
                                                    <TextField
                                                        label={data.label}
                                                        variant="outlined"
                                                        value={state[data.name]}
                                                        className={`w-100`}
                                                        disabled
                                                    />
                                                </div>
                                            </Grid>
                                        ))}
                                        {allAttributes !== null && allAttributes.map((data, i) => (
                                            data.name === "weight" &&
                                            <Grid item key={i}
                                                  lg={4} xl={4}
                                                  className="d-flex justify-content-center align-items-center"
                                            >
                                                <div
                                                    className={`ContentCreateAttribute flex-column ${
                                                        data.focused ? `selected` : `unSelected`} ${
                                                        data.name === "bookPrices" ? `justify-content-start` : ``}`}
                                                >
                                                    {data.type.name === "text" &&
                                                    <TextField
                                                        key={i}
                                                        disabled
                                                        label={data.label}
                                                        variant="outlined"
                                                        value={state[data.name]}
                                                        className={`w-100`}
                                                    />
                                                    }
                                                </div>
                                            </Grid>
                                        ))}
                                    </div>
                                    <div className="divParentTitleBasicInformation mt-5">
                                        <h3>بارگذاری فایل</h3>
                                        <hr className="w-100"/>
                                        <i
                                            // onClick={() => {
                                            //     setOpen(!open)
                                            // }}
                                            className="fas fa-chevron-down"
                                            // style={{transform: open ? "rotate(180deg)" : ""}}
                                        />
                                    </div>
                                    <div className="mt-4 ParentTableFileCreateProduct">
                                        <TableContainer component={Paper}>
                                            <Table className={classes.table} aria-label="simple table">
                                                <TableBody>
                                                    {files.map((row) => {
                                                        return <TableRow key={row.name}>
                                                            <TableCell align="right">
                                                                <i className="far fa-file-image IconFileUpload"/>
                                                            </TableCell>
                                                            <TableCell align="right">
                                                                {row.name}
                                                            </TableCell>
                                                            <TableCell align="right"
                                                                       className="dir-ltr">{humanFileSize(row.size)}</TableCell>
                                                            <TableCell align="right">{row.type}</TableCell>
                                                            <TableCell
                                                                align="right">{(new Date().getTime() - new Date(row.lastModified).getTime()) / 1000}</TableCell>
                                                            <TableCell align="right">
                                                                <i
                                                                    className="fas fa-times c-pointer"
                                                                    onClick={() => setFiles(files.filter(x => x.name !== row.name))}
                                                                />
                                                            </TableCell>
                                                        </TableRow>
                                                    })}
                                                </TableBody>
                                            </Table>
                                        </TableContainer>
                                    </div>
                                </div>
                                }
                                <div className="my-3 mr-4">

                                    {activeStep <= 0 &&
                                    <Button
                                        onClick={() => setOpenDialog(true)}
                                        className="changeTypeButtonCreateProduct"
                                    >
                                        تغییر نوع محصول
                                    </Button>
                                    }
                                    {activeStep !== 0 &&
                                    <Button onClick={handleBack} className={classes.button}>
                                        مرحله قبلی
                                    </Button>
                                    }
                                    <Button
                                        variant="contained"
                                        onClick={handleNext}
                                        className="continuationButtonCreateProduct mr-3"
                                        // disabled={setDisableNextButton(activeStep)}
                                    >
                                        {activeStep === steps.length - 1 ? 'درج' : `ادامه | ${activeStep + 1}`}
                                    </Button>
                                </div>
                            </div>
                        )}
                    </div>
                </div>
            </Grid>
        </Scrollbar>
    );
}

export default function IntegrationNotistack() {
    return (
        <SnackbarProvider maxSnack={3} anchorOrigin={{vertical: "top", horizontal: "center"}}>
            <CreateProduct/>
        </SnackbarProvider>
    );
}